import {
  ExportAttendanceEmployeeByDayRequest,
  ExportAttendanceEmployeeByDayResponse,
  ExportAttendanceEmployeeByRangeDayRequest,
  ExportAttendanceEmployeeByRangeDayResponse,
  ExportAttendanceTotalEmployeeByRangeDayRequest,
  ExportAttendanceTotalEmployeeByRangeDayResponse,
  GetAttendanceEmployeeByDayRequest,
  GetAttendanceEmployeeByDayResponse,
  GetAttendanceEmployeeByRangeDayRequest,
  GetAttendanceEmployeeByRangeDayResponse,
  GetAttendanceTotalEmployeeByRangeDayRequest,
  GetAttendanceTotalEmployeeByRangeDayResponse,
} from '@/types/apis/attendanceEmployee'

import axios from './axios'

const API_ENDPOINT = '/attendance'

export const getAttendanceEmployeeByDay = (
  request: GetAttendanceEmployeeByDayRequest
): Promise<GetAttendanceEmployeeByDayResponse> => {
  return axios.get(`${API_ENDPOINT}/employee-by-date`, { params: request })
}

export const exportAttendanceEmployeeByDay = (
  request: ExportAttendanceEmployeeByDayRequest
): Promise<ExportAttendanceEmployeeByDayResponse> => {
  return axios.get(`${API_ENDPOINT}/export-employee-by-date`, { params: request })
}

export const getAttendanceEmployeeByRangeDay = (
  request: GetAttendanceEmployeeByRangeDayRequest
): Promise<GetAttendanceEmployeeByRangeDayResponse> => {
  return axios.get(`${API_ENDPOINT}/employee-by-range-date`, { params: request })
}

export const exportAttendanceEmployeeByRangeDay = (
  request: ExportAttendanceEmployeeByRangeDayRequest
): Promise<ExportAttendanceEmployeeByRangeDayResponse> => {
  return axios.get(`${API_ENDPOINT}/export-employee-by-range-date`, { params: request })
}

export const getAttendanceTotalEmployeeByRangeDay = (
  request: GetAttendanceTotalEmployeeByRangeDayRequest
): Promise<GetAttendanceTotalEmployeeByRangeDayResponse> => {
  return axios.get(`${API_ENDPOINT}/total-employee-by-range-date`, { params: request })
}

export const exportAttendanceTotalEmployeeByRangeDay = (
  request: ExportAttendanceTotalEmployeeByRangeDayRequest
): Promise<ExportAttendanceTotalEmployeeByRangeDayResponse> => {
  return axios.get(`${API_ENDPOINT}/export-total-employee-by-range-date`, { params: request })
}
